export const detailStatuses = {
  SUCCESS: 0,
  CREDIT_CHECK_FAILED: 1,
  UPFRONT_PAYMENT_REQUIRED: 2
};
